import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { Button, TextField, Grid, Paper, Table, TableBody, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress } from '@material-ui/core';
import { BankForm, BankHeader, BankList, bankFilters, bankObj } from '../components';
import { DeletePopUp, PageLoader, STableLoader, FilterComponent, EmptyCollection, Pagination, RevisionHistory } from '../../../shared_elements'
import { globalGetService, globalPostService, globalPutService, globalDeleteService } from '../../../../globalServices';
import { checkApiStatus, checkPermission } from '../../../utils_v2';
import ConfigData from '../../master/components/ConfigData';
import AddIcon from '@material-ui/icons/Add';

const RejectionBanking = ({ rejectBank, toggleModalFn, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [reason, setReason] = useState('');
    const [error, setError] = useState({});
    const onRejection = () => {
        let validationInputs = {
            reason: reason?.trim()?.length ? '' : 'Please enter Rejection Reason',
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, rejectBank.data)
            globalPutService(`console/bank-details/${rejectBank.data.id}/`, { ...payload, lessor: rejectBank.data.lessor.id, lessor_level: rejectBank.data.lessor.lessor_level, status: 2, rejection_reason: reason })
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar('Banking detail got rejected', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        toggleModalFn(); getResponseBack();
                    }
                    setLoading(false);
                })
        } else {
            setError(validationInputs)
        }
    }
    return (
        <Dialog
            open={rejectBank.modal}
            onClose={toggleModalFn}
            className='console-management-modal add-edit-role-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                Reason of Rejection
            </DialogTitle>
            <DialogContent dividers={true}>
                <div style={{ width: '320px' }}>
                    <TextField
                        required
                        id='reason'
                        label='Reason'
                        value={reason}
                        error={error.reason}
                        helperText={error?.reason || ''}
                        onFocus={() => setError({ ...error, 'reason': '' })}
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4}
                        maxRows={4}
                        onChange={(e) => setReason(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onRejection} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Reject'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const AddEditBank = ({ owners, addEditBanking, getResponseBack, toggleModalFn }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [bank, setBank] = useState(addEditBanking?.data || {})
    const [error, setError] = useState({});
    const onFieldChange = (key, value) => {
        setBank({ ...bank, [key]: value });
    }
    const onAddEditBank = () => {
        let validationInputs = {
            lessor: bank?.lessor ? '' : 'Please select Lessor',
            name: bank?.name?.trim()?.length ? '' : 'Please enter Bank Name',
            account_name: bank?.account_name?.trim()?.length ? '' : 'Please enter Account Holder Name',
            account_number: bank?.account_number?.trim()?.length ? '' : 'Please enter Account Number'
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, bank);
            payload = {
                ...payload,
                lessor: bank.lessor.id,
                lessor_level: bank.lessor.lessor_level
            }
            if (bank.id) {
                globalPutService(`console/bank-details/${bank.id}/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            toggleModalFn(); getResponseBack();
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        }
                        setLoading(false);
                    })
            } else {
                globalPostService(`console/bank-details/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            toggleModalFn(); getResponseBack();
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        }
                        setLoading(false);
                    })
            }
        } else {
            setError(validationInputs);
        }
    }
    return (
        <Dialog
            open={addEditBanking.modal}
            className='console-management-modal add-edit-role-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {addEditBanking.mode === 'add' ? 'Add' : addEditBanking.mode === 'edit' ? 'Edit' : 'View'}  Bank
            </DialogTitle>
            <DialogContent dividers={true}>
                <BankForm
                    addEditBanking={addEditBanking}
                    lessor={owners}
                    onFieldChange={onFieldChange}
                    bank={bank}
                    error={error}
                    onResetError={(key) => setError({ ...error, [key]: '' })}
                />
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'> {addEditBanking.mode !== 'view' ? 'Cancel' : 'Close'}</Button>
                {addEditBanking.mode !== 'view' ?
                    <Button disabled={isLoading} onClick={onAddEditBank} color='primary' size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={24} /> : 'Save'}
                    </Button> : null
                }

            </DialogActions>
        </Dialog>
    )
}
const Bankings = ({ }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [addEditBanking, setAddEditBanking] = useState({ modal: false, mode: '', data: null })
    const [bankingList, setBankingList] = useState({list: [], pagination: {}});
    const [owners, setOwners] = useState([]);
    const [deleteBank, setDeleteBank] = useState({ modal: false, data: null })
    const [rejectBank, setRejectBank] = useState({ modal: false, data: null })
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    useEffect(() => {
        getBankings({per_page: 50}, 'skeletonLoader');
        getOwners()
    }, []);
    const getOwners = () => {
        globalGetService(`console/owner/`, { dropdown: true })
            .then(response => {
                if (checkApiStatus(response)) {
                    setOwners(response.data.data)
                }
            })
    }
    const getBankings = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        // keep the active sort on every refetch (pagination, filter, edit, delete)
        let queryParams = { ...(sortInfo.sort ? sortInfo : {}), ...query };
        if (queryParams?.lessor_id) {
            queryParams = {
                ...queryParams,
                lessor_level: owners.find(item => item.id === query.lessor_id)?.lessor_level
            }
        }
        globalGetService(`console/bank-details/`, queryParams)
            .then(response => {
                if (checkApiStatus(response)) {
                    setBankingList(response.data.data);
                    let filterQuery = Object.assign({}, query);
                    delete filterQuery.page
                    delete filterQuery.per_page
                    delete filterQuery.sort
                    delete filterQuery.sort_by
                    setFilter(filterQuery)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getBankings({ ...filter, ...sortQuery, page: 1, per_page: bankingList?.pagination?.per_page || 50 }, 'pageLoader');
    }
    const onDeleteBank = () => {
        setLoading(true)
        globalDeleteService(`console/bank-details/${deleteBank.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteBank({ modal: false, data: null });
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getBankings({ ...filter, page: bankingList?.pagination?.page, per_page: bankingList?.pagination?.per_page || 50 }, 'pageLoader');
                }
                setLoading(false)
            })
    }
    const onChangeStatus = (value, bank) => {
        if (value === 2) {
            setRejectBank({ modal: true, data: bank })
        } else {
            setLoading(true);
            let payload = Object.assign({}, bank)
            globalPutService(`console/bank-details/${bank.id}/`, { ...payload, lessor: bank.lessor.id, lessor_level: bank.lessor.lessor_level, status: value })
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        getBankings({ ...filter, page: bankingList?.pagination?.page, per_page: bankingList?.pagination?.per_page || 50 }, 'pageLoader');
                    }
                    setLoading(false);
                })
        }
    }
    let filterOptions = Object.assign({}, bankFilters);
    filterOptions = {
        ...filterOptions,
        lessor_id: {
            ...filterOptions.lessor_id,
            options: owners
        }
    }
    return (
        <section className='config-container'>
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content">
                    <Paper elevation={0} style={{ padding: '4px 8px', marginBottom: "2px" }} className='console-paper'>
                        <Grid container spacing={1}>
                            <Grid item md={9}>
                                    <FilterComponent
                                        filter={filter}
                                        filterMenu={filterOptions}
                                        getResponseBack={(applyFilter) => getBankings({ ...applyFilter, page: 1, per_page: bankingList?.pagination?.per_page || 50 }, 'pageLoader')}
                                    />
                            </Grid>
                            <Grid item md={3}>  
                                <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                    {checkPermission('config_data', 'banking_details', 'C') ?
                                        <li className='list-inline-item'>
                                            <Button onClick={() => setAddEditBanking({ modal: true, mode: 'add', data: bankObj })} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem' }} /> Add Bank</Button>
                                        </li> : null}
                                    <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/console/ambankdetails/`} queryParams={{ action: '0,1,2' }} />
                                    </li>
                                </ul> 
                            </Grid>
                        </Grid>
                    </Paper>
                    {skeletonLoader ? <STableLoader count={7} /> :
                        <Paper square>
                          <div style={{ height: `${window.innerHeight - 200}px`, overflow: 'scroll' }}> 
                            <Table className='mui-table-format' stickyHeader>
                                <BankHeader sortInfo={sortInfo} createSortHandler={createSortHandler} />
                                <TableBody>
                                    {bankingList?.list?.filter(bank => bank.status !== 2).map((item, index) =>
                                        <BankList
                                            key={index}
                                            item={item}
                                            onEdit={() => setAddEditBanking({ modal: true, mode: 'edit', data: item })}
                                            onDelete={() => setDeleteBank({ modal: true, data: item })}
                                            onView={() => setAddEditBanking({ modal: true, mode: 'view', data: item })}
                                            onChangeStatus={(value) => onChangeStatus(value, item)}
                                        />
                                    )}
                                </TableBody>
                              </Table>
                                {!bankingList?.list?.length && !skeletonLoader ? <div style={{ textAlign: 'center' }}><EmptyCollection title={'No records found'} /></div> : null}
                            </div>
                        </Paper>
                    }
                    <Paper square>
                        <Pagination
                            pagination={bankingList?.pagination}
                            onChangePage={(event, newPage) => getBankings({ ...filter, page: newPage + 1, per_page: bankingList?.pagination?.per_page }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getBankings({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>
                </div>
            </Paper>
            {addEditBanking.modal ?
                <AddEditBank
                    owners={owners}
                    addEditBanking={addEditBanking}
                    getResponseBack={() => getBankings({ ...filter, page: bankingList?.pagination?.page, per_page: bankingList?.pagination?.per_page || 50 }, 'pageLoader')}
                    toggleModalFn={() => setAddEditBanking({ modal: false, data: null })}
                /> : null
            }
            {deleteBank.modal ?
                <DeletePopUp
                    modal={deleteBank.modal}
                    title='Delete Bank'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteBank({ modal: false, data: null })}
                    deleteRecordFn={onDeleteBank}
                /> : null
            }
            {rejectBank.modal ?
                <RejectionBanking
                    rejectBank={rejectBank}
                    toggleModalFn={() => setRejectBank({ modal: false, data: null })}
                    getResponseBack={() => getBankings({ ...filter, page: bankingList?.pagination?.page, per_page: bankingList?.pagination?.per_page || 50 }, 'pageLoader')}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default Bankings;